import React, { createContext, useContext, useState, useEffect } from 'react';

const ImpersonationContext = createContext({});

export const useImpersonation = () => {
  const context = useContext(ImpersonationContext);
  if (!context) {
    throw new Error('useImpersonation must be used within ImpersonationProvider');
  }
  return context;
};

export const ImpersonationProvider = ({ children }) => {
  // Try to load from localStorage to persist across reloads
  const [impersonationState, setImpersonationState] = useState(() => {
    try {
      const saved = localStorage.getItem('pc_impersonation');
      if (saved) return JSON.parse(saved);
    } catch (e) {
      console.warn('Failed to parse impersonation state');
    }
    return {
      active: false,
      userId: null,
      childId: null,
      viewType: null, // 'parent' or 'child'
      displayName: '',
      tier: 'free'
    };
  });

  useEffect(() => {
    if (impersonationState.active) {
      localStorage.setItem('pc_impersonation', JSON.stringify(impersonationState));
    } else {
      localStorage.removeItem('pc_impersonation');
    }
  }, [impersonationState]);

  const startImpersonation = (config) => {
    setImpersonationState({
      active: true,
      userId: config.userId,
      childId: config.childId || null,
      viewType: config.viewType || 'parent',
      displayName: config.displayName || 'Test User',
      tier: config.tier || 'free'
    });
  };

  const stopImpersonation = () => {
    setImpersonationState({
      active: false,
      userId: null,
      childId: null,
      viewType: null,
      displayName: '',
      tier: 'free'
    });
  };

  const value = {
    ...impersonationState,
    startImpersonation,
    stopImpersonation
  };

  return (
    <ImpersonationContext.Provider value={value}>
      {children}
    </ImpersonationContext.Provider>
  );
};

export default ImpersonationProvider;
